export default "__VITE_ASSET__ClAjw9i___"